import { useTexte } from '../../texte'

/**
 * Who sets which colour, as a drawing (#92, 1.55.0).
 *
 * From the issue: "Zusammenhänge einfach grafisch darstellen (z.B.
 * Farbeinstellungen)." Three sources on the left, what each one reaches on
 * the right. The rows of the table stay below it as text, because a drawing
 * reads aloud as nothing -- the whole graphic is one `role="img"` with one
 * sentence, not fourteen unlabelled shapes.
 *
 * **The colours come from `tokens.css` and nowhere else** (CLAUDE.md): the
 * drawing has to hold in the dark mode, and a hard-coded grey would sit as
 * a light grey on black.
 *
 * **The type sizes are attributes here, not a rule in the stylesheet**, and
 * that is the one place where a number belongs in the markup: inside a
 * `viewBox` a size is a drawing unit like `x` and `width`, and it scales
 * with the picture. A `px` rule in `app.css` would look the same and be
 * something else -- it would not follow the *Schriftgröße* setting, which
 * is what the guard in `tools/pruefstand/inlinestil.ts` watches for. The
 * picture follows that setting through its width in `rem`.
 *
 * **Every word comes from `handbuch.farben`**, including the short ones:
 * a box here is 118 units wide, and cutting a sentence off with an ellipsis
 * in code would be a text in the code. So the rows carry `bildWas` and
 * `bildWo` next to the full wording.
 */
export function Farbwege() {
  const t = useTexte().handbuch.farben
  // Eine Zeile ist 40 hoch, zwischen zwei liegen 10: die Höhe kommt aus dem
  // Platz in der Liste, nicht aus einer zweiten Aufzählung daneben.
  const hoehe = (i: number) => 12 + i * 50

  return (
    <svg
      className="farbwege"
      data-farbwege=""
      viewBox="0 0 320 164"
      role="img"
      aria-label={t.bild}
      focusable="false"
    >
      <defs>
        <marker id="farbwege-spitze" viewBox="0 0 8 8" refX="7" refY="4" markerWidth="5" markerHeight="5" orient="auto">
          <path d="M0 0 L8 4 L0 8 z" fill="currentColor" />
        </marker>
      </defs>

      {t.zeilen.map((zeile, i) => {
        const y = hoehe(i)
        return (
          <g key={zeile.wer}>
            {/* Die Quelle: wer stellt ein. Der Streifen links trägt die Farbe,
                um die es in dieser Zeile geht. */}
            <rect x="1" y={y} width="118" height="40" rx="10" className="farbwege__quelle" />
            <rect x="1" y={y} width="5" height="40" rx="2.5" className={`farbwege__marke farbwege__marke--${i}`} />
            <text x="16" y={y + 24} fontSize={12} className="farbwege__name">{zeile.wer}</text>

            <path d={`M122 ${y + 20} H194`} className="farbwege__pfeil" markerEnd="url(#farbwege-spitze)" />

            {/* Das Ziel: was die Farbe färbt, und wie weit sie reicht. */}
            <rect x="200" y={y} width="119" height="40" rx="10" className="farbwege__ziel" />
            <text x="212" y={y + 18} fontSize={12} className="farbwege__was">{zeile.bildWas}</text>
            <text x="212" y={y + 32} fontSize={11} className="farbwege__wo">{zeile.bildWo}</text>
          </g>
        )
      })}
    </svg>
  )
}
